// extracted by mini-css-extract-plugin
module.exports = {"container":"page-footer-partial_container__1pTVD","main":"page-footer-partial_main__UcjLU","logo":"page-footer-partial_logo__5wG2t"};